// src/persona/registry.ts
var PERSONA_REGISTRY = {
  // P1 민지 — 블로그 입문자
  "beginner-blogger": {
    id: "beginner-blogger",
    name: "\uBE14\uB85C\uADF8 \uC785\uBB38\uC790",
    characterName: "\uBBFC\uC9C0",
    description: "\uBE14\uB85C\uADF8\uB97C \uC2DC\uC791\uD588\uC9C0\uB9CC \uBC29\uBB38\uC790\uC640 \uB178\uCD9C\uC774 \uC801\uC5B4 \uB9C9\uB9C9\uD55C \uCD08\uBCF4 \uBE14\uB85C\uAC70",
    primaryGoal: "\uC5B4\uB5A4 \uD0A4\uC6CC\uB4DC\uB85C \uAE00\uC744 \uC368\uC57C \uAC80\uC0C9\uC5D0 \uB178\uCD9C\uB418\uB294\uC9C0 \uC54C\uACE0 \uC2F6\uC74C",
    preferredLayoutMode: "agent-first",
    preferredAgentId: "dashboard-briefer",
    recommendedTier: "free",
    activationCriteria: {
      minChatMessages: 3,
      minToolCalls: 2,
      requiredToolsUsed: ["list_keywords", "keyword_detail"],
      minSessionMinutes: 5,
      firstWeekReturn: true
    },
    welcomeMessage: "\uBE14\uB85C\uADF8\uB97C \uC2DC\uC791\uD558\uC168\uAD70\uC694! AI\uAC00 \uAC80\uC0C9\uC5D0 \uC798 \uB178\uCD9C\uB418\uB294 \uD0A4\uC6CC\uB4DC\uB97C \uCC3E\uC544\uB4DC\uB9B4\uAC8C\uC694. \uC5B4\uB5A4 \uC8FC\uC81C\uB85C \uAE00\uC744 \uC4F0\uACE0 \uACC4\uC2E0\uAC00\uC694?",
    starterQuestions: [
      "\uBE14\uB85C\uADF8 \uD0A4\uC6CC\uB4DC \uC5B4\uB5BB\uAC8C \uCC3E\uC544?",
      "\uB0B4 \uBE14\uB85C\uADF8 \uC8FC\uC81C\uC5D0 \uB9DE\uB294 \uD0A4\uC6CC\uB4DC \uCD94\uCC9C\uD574\uC918",
      "\uACBD\uC7C1\uC774 \uB0AE\uC740 \uD0A4\uC6CC\uB4DC\uAC00 \uBB50\uC57C?",
      "\uC774\uBC88 \uC8FC\uC5D0 \uC4F8 \uAE00\uAC10 \uCD94\uCC9C\uD574\uC918"
    ],
    helpDensity: "high"
  },
  // P2 승현 — 콘텐츠 마케터 (파워 블로거)
  "power-blogger": {
    id: "power-blogger",
    name: "\uCF58\uD150\uCE20 \uB9C8\uCF00\uD130",
    characterName: "\uC2B9\uD604",
    description: "\uD074\uB77C\uC774\uC5B8\uD2B8 \uBCF4\uACE0\uC11C\uC5D0 \uB123\uC744 \uB370\uC774\uD130\uAC00 \uD544\uC694\uD55C \uB9C8\uCF00\uD305 \uB300\uD589\uC0AC \uD300\uC6D0",
    primaryGoal: "\uD074\uB77C\uC774\uC5B8\uD2B8\uBCC4 \uD0A4\uC6CC\uB4DC \uC131\uACFC \uD30C\uC545 \uBC0F \uC8FC\uAC04 \uBCF4\uACE0\uC11C \uC790\uB3D9\uD654",
    preferredLayoutMode: "split-view",
    preferredAgentId: "content-auditor",
    recommendedTier: "starter",
    activationCriteria: {
      minChatMessages: 3,
      minToolCalls: 3,
      requiredToolsUsed: ["list_contents", "score_url"],
      minSessionMinutes: 10,
      firstWeekReturn: true
    },
    welcomeMessage: "\uCF58\uD150\uCE20 \uB9C8\uCF00\uD305\uC744 \uB2F4\uB2F9\uD558\uACE0 \uACC4\uC2DC\uB294\uAD70\uC694! \uD074\uB77C\uC774\uC5B8\uD2B8 \uCC44\uB110\uC758 SEO \uD604\uD669\uC744 \uBD84\uC11D\uD558\uACE0 \uBCF4\uACE0\uC11C \uC791\uC131\uC744 \uB3C4\uC640\uB4DC\uB9B4\uAC8C\uC694.",
    starterQuestions: [
      "\uB0B4 \uACBD\uC7C1 \uBE14\uB85C\uADF8 \uBD84\uC11D\uD574\uC918",
      "\uD074\uB77C\uC774\uC5B8\uD2B8 \uCF58\uD150\uCE20 SEO \uC810\uC218 \uC54C\uB824\uC918",
      "\uD0A4\uC6CC\uB4DC \uC21C\uC704 \uBCC0\uB3D9 \uBAA8\uB2C8\uD130\uB9C1\uD574\uC918",
      "\uC8FC\uAC04 \uBCF4\uACE0\uC11C\uC6A9 \uB370\uC774\uD130 \uBF51\uC544\uC918"
    ],
    helpDensity: "medium"
  },
  // P3 정우 — SEO 전문가
  "seo-expert": {
    id: "seo-expert",
    name: "SEO \uC804\uBB38\uAC00",
    characterName: "\uC815\uC6B0",
    description: "\uB370\uC774\uD130\uB97C \uC9C1\uC811 \uBCF4\uACE0 \uD310\uB2E8\uD558\uB294 SEO \uCEE8\uC124\uD134\uD2B8 1\uC778 \uC0AC\uC5C5\uC790",
    primaryGoal: "\uB300\uADDC\uBAA8 \uD0A4\uC6CC\uB4DC \uD3EC\uD2B8\uD3F4\uB9AC\uC624 \uAD00\uB9AC \uBC0F \uCEE4\uC2A4\uD140 \uBD84\uC11D \uD30C\uC774\uD504\uB77C\uC778 \uAD6C\uCD95",
    preferredLayoutMode: "detail-first",
    preferredAgentId: "full-analyst",
    recommendedTier: "pro",
    activationCriteria: {
      minChatMessages: 2,
      minToolCalls: 5,
      requiredToolsUsed: ["keyword_rankings", "monitoring_changes"],
      minSessionMinutes: 15
    },
    welcomeMessage: "SEO \uC804\uBB38\uAC00\uC2DC\uAD70\uC694! \uB300\uADDC\uBAA8 \uD0A4\uC6CC\uB4DC \uD3EC\uD2B8\uD3F4\uB9AC\uC624\uC640 SERP \uBCC0\uB3D9\uC744 \uBD84\uC11D\uD574 \uB4DC\uB9B4\uAC8C\uC694. \uC5B4\uB5A4 \uD504\uB85C\uC81D\uD2B8\uB97C \uC9C4\uD589 \uC911\uC774\uC2E0\uAC00\uC694?",
    starterQuestions: [
      "\uD0A4\uC6CC\uB4DC \uD3EC\uD2B8\uD3F4\uB9AC\uC624 \uC804\uCCB4 \uBD84\uC11D\uD574\uC918",
      "\uAC80\uC0C9\uACB0\uACFC \uBCC0\uB3D9 \uC6D0\uC778 \uBD84\uC11D\uD574\uC918",
      "\uACBD\uC7C1\uC0AC SEO \uC804\uB7B5 \uBE44\uAD50\uD574\uC918",
      "\uCEE4\uC2A4\uD140 \uC5D0\uC774\uC804\uD2B8 \uB9CC\uB4DC\uB294 \uBC29\uBC95 \uC54C\uB824\uC918"
    ],
    helpDensity: "low"
  },
  // P4 수아 — 스마트스토어 셀러
  "ecommerce-seller": {
    id: "ecommerce-seller",
    name: "\uC2A4\uB9C8\uD2B8\uC2A4\uD1A0\uC5B4 \uC140\uB7EC",
    characterName: "\uC218\uC544",
    description: "\uC0C1\uD488\uBA85\uC5D0 \uCD5C\uC801 \uD0A4\uC6CC\uB4DC\uB97C \uB123\uACE0 \uC2F6\uC740 \uC2A4\uB9C8\uD2B8\uC2A4\uD1A0\uC5B4 \uC6B4\uC601\uC790",
    primaryGoal: "\uC0C1\uD488\uBA85 \uCD5C\uC801 \uD0A4\uC6CC\uB4DC \uC870\uD569 \uCC3E\uAE30 \uBC0F \uAD11\uACE0 \uC785\uCC30\uAC00 \uC801\uC815\uC120 \uD30C\uC545",
    preferredLayoutMode: "agent-first",
    preferredAgentId: "keyword-analyst",
    recommendedTier: "starter",
    activationCriteria: {
      minChatMessages: 3,
      minToolCalls: 3,
      requiredToolsUsed: ["list_keyword_bids", "keyword_overview"],
      minSessionMinutes: 8,
      firstWeekReturn: true
    },
    welcomeMessage: "\uC2A4\uB9C8\uD2B8\uC2A4\uD1A0\uC5B4\uB97C \uC6B4\uC601\uD558\uACE0 \uACC4\uC2DC\uB294\uAD70\uC694! \uC0C1\uD488\uBA85\uC5D0 \uB4E4\uC5B4\uAC08 \uCD5C\uC801 \uD0A4\uC6CC\uB4DC\uC640 \uAD11\uACE0 \uC785\uCC30\uAC00 \uC804\uB7B5\uC744 \uCC3E\uC544\uB4DC\uB9B4\uAC8C\uC694. \uC5B4\uB5A4 \uC0C1\uD488\uC744 \uD310\uB9E4\uD558\uC2DC\uB098\uC694?",
    starterQuestions: [
      "\uB0B4 \uC0C1\uD488 \uD0A4\uC6CC\uB4DC \uBD84\uC11D\uD574\uC918",
      "\uC801\uC815 \uC785\uCC30\uAC00 \uC54C\uB824\uC918",
      "\uC2DC\uC98C \uD2B8\uB80C\uB4DC \uD0A4\uC6CC\uB4DC \uCC3E\uC544\uC918",
      "\uACBD\uC7C1 \uC140\uB7EC \uAC80\uC0C9 \uB178\uCD9C \uC804\uB7B5 \uC54C\uB824\uC918"
    ],
    helpDensity: "medium"
  },
  // P5 하은 — 에이전시 팀장
  "agency-consultant": {
    id: "agency-consultant",
    name: "\uC5D0\uC774\uC804\uC2DC \uCEE8\uC124\uD134\uD2B8",
    characterName: "\uD558\uC740",
    description: "\uD300 \uC804\uCCB4\uAC00 \uD558\uB098\uC758 \uD50C\uB7AB\uD3FC\uC5D0\uC11C \uC791\uC5C5\uD558\uAE38 \uC6D0\uD558\uB294 \uB514\uC9C0\uD138 \uB9C8\uCF00\uD305 \uC5D0\uC774\uC804\uC2DC \uD300\uC7A5",
    primaryGoal: "\uD074\uB77C\uC774\uC5B8\uD2B8\uBCC4 \uCEE4\uC2A4\uD140 \uC5D0\uC774\uC804\uD2B8 \uAD6C\uCD95 \uBC0F \uBCF4\uACE0\uC11C \uC790\uB3D9\uD654",
    preferredLayoutMode: "split-view",
    preferredAgentId: "full-analyst",
    recommendedTier: "enterprise",
    activationCriteria: {
      minChatMessages: 2,
      minToolCalls: 3,
      requiredToolsUsed: ["list_keywords", "list_contents"],
      minSessionMinutes: 10
    },
    welcomeMessage: "\uC5D0\uC774\uC804\uC2DC\uB97C \uC6B4\uC601\uD558\uACE0 \uACC4\uC2DC\uB294\uAD70\uC694! \uD074\uB77C\uC774\uC5B8\uD2B8\uBCC4 \uCEE4\uC2A4\uD140 \uC5D0\uC774\uC804\uD2B8\uC640 \uBCF4\uACE0\uC11C \uC790\uB3D9\uD654\uB85C \uD300 \uC0DD\uC0B0\uC131\uC744 \uB192\uC5EC\uB4DC\uB9B4\uAC8C\uC694.",
    starterQuestions: [
      "\uD074\uB77C\uC774\uC5B8\uD2B8\uBCC4 \uC131\uACFC \uD55C\uB208\uC5D0 \uBCF4\uB294 \uBC29\uBC95 \uC54C\uB824\uC918",
      "\uCEE4\uC2A4\uD140 \uC5D0\uC774\uC804\uD2B8 \uB9CC\uB4DC\uB294 \uBC29\uBC95 \uC54C\uB824\uC918",
      "\uC8FC\uAC04 \uBCF4\uACE0\uC11C \uC790\uB3D9 \uC0DD\uC131\uD574\uC918",
      "\uD300\uC6D0 \uAD8C\uD55C \uAD00\uB9AC \uBC29\uBC95 \uC54C\uB824\uC918"
    ],
    helpDensity: "medium"
  },
  // P6 도윤 — 네이버 인플루언서
  influencer: {
    id: "influencer",
    name: "\uB124\uC774\uBC84 \uC778\uD50C\uB8E8\uC5B8\uC11C",
    characterName: "\uB3C4\uC724",
    description: "\uCC44\uB110 \uC131\uC7A5\uC744 \uC218\uCE58\uB85C \uD655\uC778\uD558\uACE0 \uC2F6\uC740 \uB124\uC774\uBC84 \uC778\uD50C\uB8E8\uC5B8\uC11C",
    primaryGoal: "\uCC44\uB110 \uC131\uC7A5 \uCD94\uC774 \uD30C\uC545 \uBC0F \uB178\uCD9C\uC5D0 \uC720\uB9AC\uD55C \uD0A4\uC6CC\uB4DC/\uC8FC\uC81C \uBC1C\uAD74",
    preferredLayoutMode: "agent-first",
    preferredAgentId: "channel-scout",
    recommendedTier: "free",
    activationCriteria: {
      minChatMessages: 3,
      minToolCalls: 2,
      requiredToolsUsed: ["channel_influencer_profile", "list_contents"],
      minSessionMinutes: 7,
      firstWeekReturn: true
    },
    welcomeMessage: "\uB124\uC774\uBC84 \uC778\uD50C\uB8E8\uC5B8\uC11C\uB85C \uD65C\uB3D9\uD558\uACE0 \uACC4\uC2DC\uB294\uAD70\uC694! \uCC44\uB110 \uC131\uC7A5 \uBD84\uC11D\uACFC \uB178\uCD9C\uC5D0 \uC720\uB9AC\uD55C \uD0A4\uC6CC\uB4DC\uB97C \uCC3E\uC544\uB4DC\uB9B4\uAC8C\uC694.",
    starterQuestions: [
      "\uB0B4 \uCC44\uB110 \uC131\uC7A5 \uCD94\uC774 \uBD84\uC11D\uD574\uC918",
      "\uACBD\uC7C1 \uC778\uD50C\uB8E8\uC5B8\uC11C \uB300\uBE44 \uB0B4 \uAC15\uC810\uC740?",
      "\uB178\uCD9C\uC5D0 \uC720\uB9AC\uD55C \uD0A4\uC6CC\uB4DC/\uC8FC\uC81C \uCC3E\uC544\uC918",
      "\uCF58\uD150\uCE20 \uD488\uC9C8 \uAC1C\uC120 \uBC29\uBC95 \uC54C\uB824\uC918"
    ],
    helpDensity: "medium"
  },
  // P7 재호 — 데이터 엔지니어 (내부/파트너)
  developer: {
    id: "developer",
    name: "\uB370\uC774\uD130 \uC5D4\uC9C0\uB2C8\uC5B4",
    characterName: "\uC7AC\uD638",
    description: "MCP API\uB97C \uC5F0\uB3D9\uD558\uC5EC \uC790\uC0AC \uB300\uC2DC\uBCF4\uB4DC\uC5D0 \uD65C\uC6A9\uD558\uB294 \uAE30\uC220 \uD30C\uD2B8\uB108\uC0AC \uC5D4\uC9C0\uB2C8\uC5B4",
    primaryGoal: "MCP \uB3C4\uAD6C \uD504\uB85C\uADF8\uB798\uBC0D \uD638\uCD9C \uBC0F \uCEE4\uC2A4\uD140 \uC5D0\uC774\uC804\uD2B8 API \uAD00\uB9AC",
    preferredLayoutMode: "detail-first",
    preferredAgentId: "full-analyst",
    recommendedTier: "enterprise",
    activationCriteria: {
      minChatMessages: 1,
      minToolCalls: 1,
      requiredToolsUsed: ["list_keywords"],
      minSessionMinutes: 5
    },
    welcomeMessage: "MCP API \uC5F0\uB3D9\uC744 \uC6D0\uD558\uC2DC\uB294\uAD70\uC694! API \uBB38\uC11C\uC640 \uC5D0\uC774\uC804\uD2B8 \uBE4C\uB354 \uC0AC\uC6A9\uBC95\uC744 \uC548\uB0B4\uD574 \uB4DC\uB9B4\uAC8C\uC694.",
    starterQuestions: [
      "MCP API \uC5F0\uB3D9 \uBC29\uBC95 \uC54C\uB824\uC918",
      "\uCEE4\uC2A4\uD140 \uC5D0\uC774\uC804\uD2B8 API\uB85C \uC0DD\uC131\uD558\uB294 \uBC29\uBC95",
      "\uB300\uB7C9 \uD0A4\uC6CC\uB4DC \uB370\uC774\uD130 \uCD94\uCD9C\uD558\uB294 \uBC29\uBC95",
      "API \uC778\uC99D \uC124\uC815 \uBC29\uBC95 \uC54C\uB824\uC918"
    ],
    helpDensity: "low"
  }
};
var PERSONA_IDS = [
  "beginner-blogger",
  "power-blogger",
  "seo-expert",
  "ecommerce-seller",
  "agency-consultant",
  "influencer",
  "developer"
];

// src/persona/get-persona.ts
function getPersona(id) {
  return PERSONA_REGISTRY[id];
}
function getActivationCriteriaForPersona(id) {
  return PERSONA_REGISTRY[id].activationCriteria;
}
function getAllPersonas() {
  return Object.values(PERSONA_REGISTRY);
}

export {
  PERSONA_REGISTRY,
  PERSONA_IDS,
  getPersona,
  getActivationCriteriaForPersona,
  getAllPersonas
};
//# sourceMappingURL=chunk-5MHEHJ4Z.js.map